import { toast } from "sonner";

import type { Bank } from "@/types/banks";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

export function useBanks() {
	const privateAxios = usePrivateAxios();

	return useQuery({
		queryKey: ["banks"],
		queryFn: async (): Promise<Bank[]> => {
			const response = await privateAxios.get("/banks");
			return response.data.data;
		}
	});
}
export function useResolveBankDetails() {
	const privateAxios = usePrivateAxios();
	return useMutation({
		mutationKey: ["account-details"],
		mutationFn: async (params: {
			bankId: string;
			accountNumber: string;
		}) => {
			const response = await privateAxios.get("/banks/resolve", { params });
			return response.data.data;
		}
	});
}

export interface AccountDetails {
	bankCode: string;
	accountNumber: string;
	accountName: string;
}

export function useUpdateBankDetails() {
	const privateAxios = usePrivateAxios();
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: ["update-account-details"],
		mutationFn: async (body: {
			bankAccounts: {
				bankCode: string;
				accountNumber: string;
				accountName: string;
			}[];
			pin: string;
		}) => {
			const response = await privateAxios.put<{ data: AccountDetails }>("/auth/update-bank-details", body);
			return response.data.data;
		},
		onSuccess: () => toast.success("Bank details updated successfully."),
		onError: () => toast.error("Failed to update bank details."),
		onSettled: () => queryClient.invalidateQueries({ queryKey: ["user-profile"] })
	});
}
